import { DetailedPlayer, Mode } from '@par/shared/common/types';
import { Player } from './types';
import { DateTime } from 'luxon';
import { resizeImage } from '../../api/cloudinary';

export const isRemainderZero = (x: number, y: number) =>
  Math.round(x * 100) % Math.round(y * 100) === 0;

export const roundToOneDecimal = (value: number) => Math.round(value * 10) / 10;

export const roundToTwoDecimals = (value: number) =>
  Math.round(value * 100) / 100;

export const randomIntFromInterval = (min, max) => {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const findIndexOf2dArray = (arr, k) => {
  for (let i = 0; i < arr.length; i++) {
    const index = arr[i].indexOf(k);
    if (index > -1) {
      return [i, index];
    }
  }
};

const LEAGUE_TIME_LIMIT = 30;
const TIME_LIMIT = 20;

export const isTimedOut = (par: number, score: number, league?: boolean) =>
  (league ? LEAGUE_TIME_LIMIT : TIME_LIMIT) - par === score;

export const sum = (array: number[]) => array.reduce((a, b) => a + b, 0);

export const average = (array: number[]) =>
  array.length ? array.reduce((a, b) => a + b) / array.length : null;

export const movingAverage = (
  oldAverage: number,
  newValue: number,
  newTotal: number
) => oldAverage * ((newTotal - 1) / newTotal) + newValue / newTotal;

export const median = (array: number[]) => {
  const sorted = Array.from(array).sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);

  if (sorted.length % 2 === 0) {
    return (sorted[middle - 1] + sorted[middle]) / 2;
  }

  return sorted[middle];
};

export const getDateUTC = () => {
  const date = new Date();
  return date.getTime() - date.getTimezoneOffset() * 60000;
};

export const getStartOfDayPacific = () => {
  const nowInPacific = DateTime.now().setZone('America/Los_Angeles');
  const startOfTodayPacific = nowInPacific.startOf('day');
  const milliseconds = startOfTodayPacific.toMillis();
  return milliseconds;
};

export const utcToLocalTime = (ms: number) => {
  const date = new Date(ms);
  return date.toLocaleTimeString();
};

export const utcToLocalDateTime = (ms: number) => {
  const date = new Date(ms);
  return date.toLocaleString();
};

export const utcToLocalDate = (ms: number) => {
  const date = new Date(ms);
  return date.toLocaleDateString();
};

export const utcToLocalDateLong = (ms: number) => {
  const options: any = {
    weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  const date = new Date(ms);
  return date.toLocaleDateString('en-us', options);
};

// handles ties like 1, 2, 2, 4
export const assignRanks = (players: Player[] | DetailedPlayer[]) => {
  const clonedPlayers = structuredClone(players);
  let prevScore: number;
  let currentRank: number;
  clonedPlayers.forEach((player, index) => {
    if (player.parScore !== prevScore) {
      player.rank = index + 1;
      currentRank = index + 1;
    } else {
      player.rank = currentRank;
    }
    prevScore = player.parScore;
  });
  return clonedPlayers;
};

export const isGif = (src: string) => {
  if (!src) return false;
  return src.toLowerCase().includes('.gif');
};

export const transformCloudinaryGifToStill = (src: string) => {
  const lastIndex = src.lastIndexOf('upload/') + 7;
  const newSrc = src.slice(0, lastIndex) + 'pg_1/' + src.slice(lastIndex);
  return newSrc;
};

export const getAbbreviatedDayOfTheWeek = (dateInMs: number) => {
  const d = new Date(dateInMs);
  switch (d.getDay()) {
    case 0:
      return 'Sun';
    case 1:
      return 'Mon';
    case 2:
      return 'Tue';
    case 3:
      return 'Wed';
    case 4:
      return 'Thu';
    case 5:
      return 'Fri';
    case 6:
      return 'Sat';
  }
  return 'Sun';
};

export const findMark = (val: number, marks: any) =>
  [...marks].reverse().find((mark) => val > mark.value);

export const getAvatarSrc = (
  avatarPublicId: string,
  avatarUrl: string,
  width: number,
  height: number
) => {
  if (avatarPublicId) {
    return resizeImage(avatarPublicId, width, height);
  }
  if (avatarUrl) {
    return avatarUrl;
  }
  return null;
};
